import images from "./images";

const offers = [
    {
        id: 1,
        image: images.offer1,
        title: "Weekend Getaway Deal",
        discount: "Save 15% on rentals",
        validUntil: "2025.02.22 - 23:00"
    },
    {
        id: 2,
        image: images.offer2,
        title: "Lengthy Rental Offer",
        discount: "Get 20% off for 7+ days",
        validUntil: "2025.03.01 - 23:00"
    },
    {
        id: 3,
        image: images.offer3,
        title: "Early Booking Discount",
        discount: "Book now & save 10%",
        validUntil: "2025.02.28 - 23:00"
    },
    {
        id: 4,
        image: images.offer4,
        title: "Luxury Car Weekend Deal",
        discount: "Get 15% off luxury rentals",
        validUntil: "2025.02.22 - 23:00"
    },
    {
        id: 5,
        image: images.offer5,
        title: "Business Trip Special",
        discount: "Exclusive 20% off on executive cars",
        validUntil: "2025.03.01 - 23:00"
    },
    {
        id: 6,
        image: images.offer6,
        title: "Airport Transfer Discount",
        discount: "Book now & save 10% on airport pickups",
        validUntil: "2025.02.28 - 23:00"
    },
];

export default offers;